//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sync } from 'vuex-pathify'
import ColumnsSelect from '@/components/ColumnsSelect'
import WhatsappBtn from '@/components/WhatsappBtn'
import RolSearchChip from './promotor/rol/RolSearchChip'
import StatusButton from './promotor/status/StatusButton'
import Promotor from '@/api/promotores/usuarios.api'

export default {
  components: { ColumnsSelect, RolSearchChip, StatusButton, WhatsappBtn },
  data() {
    return {
      per_page_options: [10, 20, 30, 40, 50, 100],
      columns: [
        { name: "id", label: "Id", field: "id", sortable: true, align: "left", style: "width: 10px", required: true },
        {
          name: "nombre",
          label: "Nombre",
          field: "nombre_completo",
          align: "left",
          sortable: true,
          classes: "bg-grey-2 ellipsis",
          headerClasses: "bg-primary text-white",
          required: true
        },
        { name: "email", label: "E-mail", field: "email", align: "left", sortable: true },
        { name: "curp", label: "CURP", field: "curp", align: "left" },
        { name: "rfc", label: "RFC", field: "rfc", align: "left" },
        { name: "celular", label: "Celular", field: "celular", align: "left" },
        { name: "telefono", label: "Teléfono", field: "telefono", align: "left" },
        { name: "fecha_nacimiento", label: "Fecha de nacimiento", field: "fecha_nacimiento", align: "left" },
        { name: "lugar_nacimiento", label: "Lugar de nacimiento", field: "lugar_nacimiento", align: "left" },
        { name: "genero", label: "Género", field: "genero", align: "left", format: this.formatGenero },
        { name: "rol", label: "Grupo", field: "rol", align: 'center' },
        {
          name: "created_at",
          label: "Creación",
          field: "created_at",
          align: "left",
        },
        { name: "estatus", label: "Estatus", field: "estatus", align: "center", classes: "text-capitalize", style: "width: 180px" },
      ],
      data: [],
      loading: false,
      selected: [],
    }
  },
  computed: {
    visible_columns: sync('app/visible_columns'),
    pagination: sync('app/pagination'),
    filter: sync('app/search'),
  },
  mounted() {
    if (this.$route.query.s) {
      this.filter = this.$route.query.s
    }

    this.loadPromotores();
  },
  methods: {
    async loadPromotores({ pagination, filter } = {}) {
      
      // Sets default pagination & filter
      pagination = pagination || this.pagination
      filter = filter || this.filter

      try {
        this.loading = true

        const { data, current_page, per_page, total } = await Promotor.paginate({
          page: pagination.page,
          limit: pagination.rowsPerPage,
          order: {
            column: pagination.sortBy,
            direction: pagination.descending ? "desc" : "asc"
          },
          search: filter,
        })

        this.data = data

        this.pagination = {
          page: current_page,
          rowsPerPage: per_page,
          rowsNumber: total,
          sortBy: pagination.sortBy,
          descending: pagination.descending,
        }

        this.selected = []
      } finally {
        this.loading = false
      }
    }
  }
}
